import {
  GET_NLT_CANONE_PERSONALIZZATO_V1,
  SCEGLI_CANONE_SET_ANTICIPO,
  SCEGLI_CANONE_SET_CANONE,
  SCEGLI_CANONE_SET_CANONE_PERSONALIZZATO,
  SCEGLI_CANONE_SET_NUMERO_MENSILITA,
} from '../../constants/ActionTypes'
import { createBasicCreator, fetchData } from '../Buy'

export const setSelectedAnticipo = createBasicCreator(
  SCEGLI_CANONE_SET_ANTICIPO
)

export const setSelectedNumeroMensilita = createBasicCreator(
  SCEGLI_CANONE_SET_NUMERO_MENSILITA
)

export const setSelectedCanone = createBasicCreator(SCEGLI_CANONE_SET_CANONE)

export const setCanonePersonalizzato = createBasicCreator(
  SCEGLI_CANONE_SET_CANONE_PERSONALIZZATO
)

export const getNltCanonePersonalizzatoV1 = (dispatch, getState) => {
  const { couponOrCanonePersonalizzato } = getState().nlt
  const idAuto = getState().product.id_auto

  const uri = `${
    window.brumbrum.url_api
  }/ordini/p/v1/codici/${couponOrCanonePersonalizzato}/${idAuto}?v=${new Date().getTime()}`

  return dispatch(
    fetchData(GET_NLT_CANONE_PERSONALIZZATO_V1)({
      callback: GET_NLT_CANONE_PERSONALIZZATO_V1,
      errorMessage: GET_NLT_CANONE_PERSONALIZZATO_V1,
      method: 'GET',
      uri,
    })
  )
}
